export default {
  'Custom': 'Personnalisation',
  'Original': 'Original',
}